import { render } from "./MultiTabPrevent.vue?vue&type=template&id=87b89454"
import script from "./MultiTabPrevent.vue?vue&type=script&lang=js"
export * from "./MultiTabPrevent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__